import DashboardComponent from './Dashboard'

export const Dashboard = () => {
  return <DashboardComponent />
}
